// extracted by mini-css-extract-plugin
export var ButtonGroup = "index-module--ButtonGroup--071ca";
export var ButtonGroupMargin = "index-module--ButtonGroupMargin--fb7a3";
export var ButtonGroupTile = "index-module--ButtonGroupTile--1b041";
export var Content = "index-module--Content--1231c";
export var ServingOptionList = "index-module--ServingOptionList--312c3";
export var fadeAndGrowInUp = "index-module--fadeAndGrowInUp--ab79c";